import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ShipFeaturesMap } from '~/types';


export interface State {
    shipFeaturesMap: ShipFeaturesMap,
}

export const initialState: State = {
    shipFeaturesMap: {},
};


const shipFeaturesSlice = createSlice({
    name: 'shipFeatures',
    initialState,
    reducers: {
        addFeaturesToStore(state: State, action: PayloadAction<ShipFeaturesMap>) {
            state.shipFeaturesMap = action.payload;
        },
    }
});

export default shipFeaturesSlice.reducer;


// All reducers for actions/middleware
export const shipFeaturesReducerActions = shipFeaturesSlice.actions;
